import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web/slate/Layout";
import { GrowingSpacer } from "@faire/web/slate/spacing";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import * as React from "react";
import styled from "styled-components";

import { getIsBrandPreview } from "@faire/retailer/lib/getIsBrandPreview";
import { FaireDirectBrandPreviewBanner } from "@faire/retailer/views/faire-direct/components/FaireDirectBrandPreviewBanner";
import { SignIn } from "@faire/retailer/views/faire-direct/components/SignIn";

interface IProps extends React.PropsWithChildren {
  isPreSample: boolean;
  showBorder?: boolean;
  loginUrl?: string;
}

export const PageWrapper: React.FC<IProps> = ({
  showBorder,
  children,
  loginUrl,
  isPreSample,
}) => {
  const { isMobile } = useViewport();
  const shouldHideSignIn = isPreSample || isMobile || getIsBrandPreview();
  return (
    <PageContainer>
      {shouldHideSignIn ? null : (
        <RightRow>
          <GrowingSpacer />
          <SignIn
            loginUrl={loginUrl}
            eventPath="elevate-sign-up/landing-page/click/log-in"
          />
        </RightRow>
      )}
      {getIsBrandPreview() ? <FaireDirectBrandPreviewBanner /> : null}
      {showBorder ? <Border /> : null}
      {children}
    </PageContainer>
  );
};

const PageContainer = styled(Column).attrs({ align: "center" })`
  width: 100%;
  min-height: 95vh;
`;

const Border = styled.div`
  width: calc(100% - 70px);
  height: 1px;
  background-color: ${Core.surface.subdued};
`;

const RightRow = styled(Row)`
  width: 100%;
  padding: 20px;
  background: #f9f5f0;
  margin-left: auto;
`;
